// extracted by mini-css-extract-plugin
export default {"root":"WorkFlowParameterMappings_root__pR680","heading":"WorkFlowParameterMappings_heading__kEB8C"};